var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-759.000000, -558.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(759.000000, 558.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    cx: 512,
    cy: 512,
    r: 512
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.320000, 5.320000)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#AD1C4E",
    cx: 506.6800232,
    cy: 506.6800232,
    r: 317.4400024
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M525.2234497,516.5733643l-6.3116455-197.2709045 c-0.4900513-15.3150024-13.2657776-27.6624451-28.538147-27.6624451h0.9553223 c-15.3200073,0-28.0492859,12.3848877-28.5381165,27.6624451l-7.0444336,220.17453 c-0.4242554,13.2596436,6.5632019,24.8342896,17.2427368,30.8623047 c4.3370667,3.8955688,9.7720947,6.7325439,15.9981689,8.0144043l153.233551,31.5476685 c14.8280029,3.0527954,29.991272-6.4549561,33.6859741-21.2736816l-0.2311401,0.9269409 c3.7062988-14.8649292-5.1501465-30.3087769-19.7555542-34.5981445L525.2234497,516.5733643z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.da783f18d9ae626f1dec2a4dc9df5143.svg";
export { ForwardRef as ReactComponent };